module.exports = __webpack_public_path__ + "img/illu@2x.00304f18.png";